/*
 * Created Date: Thursday May 5th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export interface DatePickerCustomProps {
  label: string;
  error?: boolean | undefined;
  helperText?: string;
  onChange: (
    value: Date | null,
    keyboardInputValue?: string | undefined
  ) => void;
  value: Date | null;
  disabled?: boolean;
  style?: any;
  textFieldValue?: string | null;
  minDate?: Date | null;
  required?: boolean;
}

const DatePickerCustom = ({
  error,
  helperText,
  label,
  disabled,
  style,
  onChange = () => {},
  value,
  textFieldValue,
  minDate,
  required,
}: DatePickerCustomProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        minDate={minDate ?? undefined}
        label={label}
        value={value}
        onChange={onChange}
        inputFormat="dd/MM/yyyy"
        PaperProps={{
          sx: {
            "& .MuiPickersDay-root": {
              backgroundColor: "transparent",
            },
            "& .MuiPickersCalendarHeader-labelContainer": {
              overflow: "visible",
            },
          },
        }}
        disabled={disabled}
        renderInput={(params: any) => (
          <TextField
            required={required}
            {...params}
            error={error}
            helperText={error ? helperText : ""}
            disabled={disabled}
            value={textFieldValue}
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              "& .MuiInputBase-root": {
                backgroundColor: "secondary.dark",
              },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiOutlinedInput-input": {
                padding: "8.5px 14px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiOutlinedInput-root ": {
                borderRadius: 1,
              },

              "& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-outlined":
                {
                  webkitTransform: "translate(14px, 9px) scale(1)",
                  transform: "translate(14px, 9px) scale(1)",
                },
              "& .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-shrink": {
                webkitTransform: "translate(14px, -9px) scale(0.75)",
                transform: "translate(14px, -9px) scale(0.75)",
              },
            }}
            InputLabelProps={{
              shrink: value ? true : undefined,
              sx: {
                userSelect: "none",
                "&.Mui-focused": {
                  color: "text.secondary",
                },
              },
            }}
            style={{ ...style }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerCustom;
